import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-general-modal',
  templateUrl: './general-modal.component.html',
  styleUrls: ['./general-modal.component.css']
})
export class GeneralModalComponent implements OnInit {
  modalHeader = "";
  modalTitle = "";
  modalDescription = "";
  isWarning: boolean = false;
  isInfo: boolean = false;
  isError: boolean = false;
  isButtonShown: boolean = false;
  isShownImage: boolean = false;
  isFooter: boolean = true;
  isConfirmation: boolean = false;
  comment!: string;
  desc!: string;
  @Output() public makeSomeOperations: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private _translateService: TranslateService,
    public dialogRef: MatDialogRef<GeneralModalComponent>,

  ) {
  }

  ngOnInit(): void {
  }
  makeOperations(valid: boolean) {
    this.makeSomeOperations.emit(valid);
  }
  closeModal() {
    this.dialogRef.close();
  }
  dosomething() {
  }
}
